import { gql } from 'apollo-angular';

export const consentFields = `
  id
  acceptedLatest
  text
`;

export const missingConsentFields = `
  type
  mandatory
  legalText
  legalTextId
`;

export const setConsentMutation = gql`
  mutation setConsent($consentType: ConsentType!, $consentId: ID!, $consentGiven: Boolean) {
    setConsent(consentType: $consentType, consentId: $consentId, consentGiven: $consentGiven)
  }
`;

export const setConsentV2Mutation = gql`
  mutation setConsentV2($legalTextId: ID!, $consentGiven: Boolean) {
    setConsentV2(legalTextId: $legalTextId, consentGiven: $consentGiven)
  }
`;

export const getConsentQuery = gql`
  query getConsent($consentType: ConsentType!) {
    getConsent(consentType: $consentType) {
      ${consentFields}
    }
  }
`;

export const getMissingConsentsQuery = gql`
  query getMissingConsents {
    getMissingConsents {
      missingConsents {
        ${missingConsentFields}
      }
    }
  }
`;

export const registerUserActivityMutation = gql`
  mutation registerUserActivity {
    registerUserActivity
  }
`;
